import styled from 'styled-components';
import { ReactComponent as VideoIcon } from '../icons/ic-video.svg';
import { ReactComponent as PdfIcon } from '../icons/ic-pdf.svg';

function GuideModal({ videoLink, pdfLink, style }) {
  return (
    <Div>
    <ModalContainer style={style}>
      {videoLink && (
        <Option onClick={() => window.open(videoLink, '_blank')}>
          <VideoIcon />
          <p>
            <span
              style={{
                color: '#848484',
                fontFamily: 'Noto Sans',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: 'normal',
              }}
            >
              동영상
            </span>
            <span
              style={{
                color: '#848484',
                fontFamily: 'Noto Sans',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: 'normal',
              }}
            >
              으로 보기
            </span>
          </p>
        </Option>
      )}
      {pdfLink && (
        <Option onClick={() => window.open(pdfLink, '_blank')}>
          <PdfIcon />

          <p>
            <span
              style={{
                color: '#848484',
                fontFamily: 'Noto Sans',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '600',
                lineHeight: 'normal',
              }}
            >
              PDF
            </span>
            <span
              style={{
                color: '#848484',
                fontFamily: 'Noto Sans',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: 'normal',
              }}
            >
              로 보기
            </span>
          </p>
        </Option>
      )}
    </ModalContainer>
    </Div>
  );
}

const Div = styled.div`
  padding: 150px 220px;
  margin: -150px -220px;
`;

const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  position: absolute;
  background-color: white;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 4px;
  z-index: 10;
  height: 110px;
  border-radius: 10px;
  border: 1px solid rgba(196, 196, 196, 0.77);
  background: #f8f8f8;
  top: -130px;
  left: -100px;

  &:after {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -24px;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-top: 24px solid #f8f8f8;
  }
  &::before {
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%) translateY(1px);
    bottom: -25px;
    border-left: 13px solid transparent;
    border-right: 13px solid transparent;
    border-top: 25px solid #d9d9d9;
  }
`;

const Option = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #e7e7e7;
  background: #fff;
  justify-content: center;
  align-items: center;
  width: 128px;
  height: 90px;
  &:hover {
    border-color: #ff7a00;
    span {
      color: #ff7a00 !important;
    }
    svg path {
      stroke: #ff7a00;
    }
  }
`;


export default GuideModal;
